import { PriceQuoteStatus } from '@wix/ambassador-wix-quotes-web/types';
import { Badge } from '@wix/design-system';
import * as React from 'react';
const getBadgePropsByStatus = (status) => {
    switch (status) {
        case PriceQuoteStatus.Draft:
            return { skin: 'neutral' };
        case PriceQuoteStatus.Sent:
            return { skin: 'neutralStandard' };
        case PriceQuoteStatus.Accepted:
            return { skin: 'success' };
        case PriceQuoteStatus.Invoiced:
            return { skin: 'neutralSuccess' };
        case PriceQuoteStatus.Rejected:
            return { skin: 'neutralDanger' };
        case PriceQuoteStatus.Expired:
            return { skin: 'neutralDanger' };
        case PriceQuoteStatus.Processing:
        case PriceQuoteStatus.Void:
        case PriceQuoteStatus.Deleted:
            return {};
    }
};
const PQStatusBadge = ({ status, dataHook, children, }) => {
    const props = getBadgePropsByStatus(status);
    return (React.createElement(Badge, { ...props, dataHook: dataHook, uppercase: false }, children));
};
export default PQStatusBadge;
//# sourceMappingURL=PQStatusBadge.js.map